module.exports = __webpack_public_path__ + "img/BatteryChargingFullOutlined.46630ba7.svg";